import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FlexRow, RightFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledInnerContentWrap = styled(RightFlexRow)`
    align-items: center;
    flex: 1 1 fit-content;
`;

export const StyledCollapsiblePanelHead = styled(FlexRow)`
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    column-gap: 4px;
    height: 50px;
    padding: 6px 8px;
    box-sizing: border-box;
`;

export const StyledPanelHead = styled(StyledCollapsiblePanelHead)`
    background-color: ${colorsPalettes.carbon["25"]};
    border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
`;

const StyledStartInnerContent = styled.div`
    margin-right: auto;
`;
